module.exports = __webpack_public_path__ + "img/naclist(14).b5f938d7.png";